var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIlobell({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0003 8.33317C15.0003 7.00709 14.4735 5.73532 13.5359 4.79764C12.5982 3.85996 11.3264 3.33317 10.0003 3.33317C8.67424 3.33317 7.40247 3.85996 6.46479 4.79764C5.52711 5.73532 5.00033 7.00709 5.00033 8.33317V14.9998H15.0003V8.33317ZM16.667 15.5557L17.0003 15.9998C17.0468 16.0617 17.075 16.1354 17.082 16.2124C17.0889 16.2895 17.0743 16.367 17.0397 16.4362C17.0051 16.5054 16.9519 16.5636 16.886 16.6043C16.8202 16.645 16.7444 16.6665 16.667 16.6665H3.33366C3.25628 16.6665 3.18043 16.645 3.1146 16.6043C3.04878 16.5636 2.99559 16.5054 2.96098 16.4362C2.92638 16.367 2.91173 16.2895 2.91868 16.2124C2.92563 16.1354 2.9539 16.0617 3.00033 15.9998L3.33366 15.5557V8.33317C3.33366 6.56506 4.03604 4.86937 5.28628 3.61913C6.53652 2.36888 8.23222 1.6665 10.0003 1.6665C11.7684 1.6665 13.4641 2.36888 14.7144 3.61913C15.9646 4.86937 16.667 6.56506 16.667 8.33317V15.5557ZM7.91699 17.4998H12.0837C12.0837 18.0524 11.8642 18.5823 11.4735 18.973C11.0828 19.3637 10.5529 19.5832 10.0003 19.5832C9.44779 19.5832 8.91789 19.3637 8.52719 18.973C8.13649 18.5823 7.91699 18.0524 7.91699 17.4998Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlobell);
export default __webpack_public_path__ + "static/media/ilobell.fff4adcfbd0dbf4e978c7c68d08026c6.svg";
export { ForwardRef as ReactComponent };